import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CommonButton from '../../common/button/Button';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),

    },
    '& .MuiDialog-paper': {
        background: "linear-gradient(138deg, #D38C02 2.28%, rgba(255, 200, 94, 0.60) 81.66%), #FFF",
        borderRadius: "20px",
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialogTitle-root':{
      padding: theme.spacing(0.5),
    },

}));

interface LotteryProps {
    data?: any;
    open?: any;
    setOpen?: any;
    lotteryIndex?:any;
    images?: any;
    settings?: any;
    verticalOrientation?: boolean;
}
const LotteryDialog: React.FC<LotteryProps> = ({ data, open, setOpen, lotteryIndex, images, settings, verticalOrientation = false }) => {
    const { t } = useTranslation('translation');

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                style={{
                    transform: verticalOrientation ? "rotate(90deg)" : "none"
                }}
                hideBackdrop
            >
                <DialogTitle
                sx={{ m: 0, color: "white", textAlign: "center", fontFamily:"IBM Plex Sans", fontWeight:"bolder" }}
                id="customized-dialog-title">
                    {t("lotterySystem")}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: "white"
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <Grid container display="flex" spacing={2}>
                        <Grid item sm={6} lg={6} xs={6}>
                            <img
                                alt="lottery"
                                src={data?.imageUrl ? data?.imageUrl : settings?.emptyTicketsDisplay in images ? `${images[settings?.emptyTicketsDisplay]}` : ""}
                                key={data?.Id}
                            />
                        </Grid >
                        <Grid item sm={6} lg={6} xs={6}>
                            <Typography color="white" className="typography-dialog">Ticket Number #{data?.ticketNumber}</Typography>
                            <Typography color="white" className="typography-dialog">Price ${data?.ticketPrice}</Typography>
                            <Typography color="white" className="typography-dialog" sx={{ mt: 3.5}}>Position {lotteryIndex + 1}</Typography>
                            {/* <CommonButton onClick={handleClose} sx={{height:"25%", color:"white", fontFamily:"Baloo 2", fontWeight:"900" }}>
                                Buy Now
                            </CommonButton> */}
                        </Grid>
                    </Grid>

                </DialogContent>
            </BootstrapDialog>
        </React.Fragment>
    );
}
export default LotteryDialog;